function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

// WhatsApp markup on already-escaped text. Order: links first (before other
// markup can touch the URL), then bold/italic/strike/mono, then newlines.
export function formatWhatsappToHtml(text: string): string {
  let out = escapeHtml(text ?? '');
  out = out.replace(
    /(https?:\/\/[^\s<]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>',
  );
  out = out.replace(/```([^`]+)```/g, '<code>$1</code>');
  out = out.replace(/`([^`]+)`/g, '<code>$1</code>');
  out = out.replace(/(^|[\s(])\*([^\s*][^*]*?)\*(?=$|[\s).,!?])/g, '$1<strong>$2</strong>');
  out = out.replace(/(^|[\s(])_([^\s_][^_]*?)_(?=$|[\s).,!?])/g, '$1<em>$2</em>');
  out = out.replace(/(^|[\s(])~([^\s~][^~]*?)~(?=$|[\s).,!?])/g, '$1<del>$2</del>');
  out = out.replace(/\n/g, '<br>');
  return out;
}
